const storeFeatureFlags = {
  sideMenu: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: false,
    Mock: false,
    Development: false,
    Local: false,
  },
  redesignDataRichTiles: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  helpAndSupport: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  dynamicAEMCapabilityBanners: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  intShopAccessForMicrosoftCSPService: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  ogwConfig: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: true,
    Mock: true,
    Development: true,
    Local: true
  },
}

export default storeFeatureFlags
